<template>
  <div class="box">
    <header class="heading has-text-centered">
      <a :href="item.link" target="_blank" rel="noopener noreferrer nofollow">
        <h2 v-if="ranking" class="title">{{item.title}}</h2>
        <h1 v-else class="title">{{item.title}}</h1>
      </a>
    </header>
    <section class="section">
      <div class="tile is-ancestor">
        <div class="tile is-parent is-7">
          <div class="tile is-child">
            <figure class="image">
              <a :href="item.link" target="_blank" rel="noopener noreferrer nofollow">
                <picture>
                  <source type="image/webp" :srcset="item.image_src_webp" />
                  <img
                    :src="item.image_src"
                    :alt="'zdjęcie ' + item.title"
                    style="max-height:25rem;width:auto;margin-left: auto;margin-right: auto;"
                  />
                </picture>
              </a>
            </figure>
          </div>
        </div>
        <div class="tile is-parent is-vertical">
          <div class="tile is-child content has-text-justified">
            <p>{{ item.description }}</p>
          </div>
          <tags :tags="item.tags"></tags>
          <div class="tile is-child content">
            <nav class="level">
              <div class="level-left">
                <div class="level-item">
                  <a :href="item.link" target="_blank" rel="noopener noreferrer nofollow">
                    <p class="title has-test-centered">{{item.price}} zł</p>
                  </a>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <a
                    :href="item.link"
                    class="button is-danger is-large is-uppercase has-text-weight-bold"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                  >Obczaj to</a>
                </div>
              </div>
            </nav>
          </div>
          <div class="tile is-child content">
            <social-share-buttons
              class="is-pulled-right"
              :title="item.title"
              :url="'https://nacocito.pl/' + item.slug + '/'"
            ></social-share-buttons>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SocialShareButtons from "./SocialShareButtons";
import Tags from "./Tags";

export default {
  name: "VerticalCard",
  props: ["item", "ranking"],
  components: {
    SocialShareButtons,
    Tags,
  },
};
</script>
